import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  addDocument: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.addDocument`,
    defaultMessage: 'Add Document',
  },
  remove: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.remove`,
    defaultMessage: 'Remove',
  },
  removeDocument: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.removeDocument`,
    defaultMessage: 'Remove Document',
  },
  removeDocumentConfirmationText: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.removeDocumentConfirmationText`,
    defaultMessage: `Are you sure you want to remove the "{title}" document?`,
  },
  documents: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.documents`,
    defaultMessage: 'Documents',
  },
  // AXHE-4446 removed the active row's badge — `offerLetterBadge`, last worded
  // "Signature template, sent by a recruiter". AXHE-4106 added it so a row would
  // say which KIND it is, AXHE-4226 rewrote it to say what that kind DOES, and
  // AXHE-4400 renamed its noun — but on a list that may hold several of them,
  // repeating one sentence per row is noise, and the sentence already appears
  // once where it belongs: DefaultDocuments' section description
  // (manageDocumentsWithOfferLetterTemplates). An active row now shows the
  // template name alone.
  //
  // BaseStageSerializer#offer_letter_templates_for_stage deliberately surfaces
  // an assigned-but-INACTIVE template so a recruiter can clear a stale
  // assignment (AXHE-3836). Rendering it identically to an active one meant the
  // detach action worked but the reason to use it was invisible — the recruiter
  // could not tell why the row was there (rantler, PR #2996). That is a broken
  // state to fix rather than a fact about the kind, so this badge survives the
  // removal above.
  //
  // "Signature template", not "Offer letter template" (AXHE-4400). The id keeps
  // the old noun deliberately — see the rule and the rename-don't-re-mint
  // reasoning in OfferLetterTemplates/messages.ts. AXHE-4400's note here covered
  // "both ids in this file"; `offerLetterBadge` is the other one, and it is gone.
  offerLetterInactiveBadge: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.offerLetterInactiveBadge`,
    defaultMessage: 'Signature template (inactive)',
  },
  // AXHE-4446: what the row says when this stage has not said who fills one of
  // the template's employer signer roles. Phrased as the action rather than the
  // state ("Signer not assigned") because the pencil next to it is where the
  // action happens, and because the consequence — the offer cannot be sent — is
  // spelled out in the modal that opens, where there is room for it.
  assignSigners: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.assignSigners`,
    defaultMessage: `{count, plural, one {Assign a signer} other {Assign signers}}`,
    description:
      'Attention label on an offer letter row whose stage has not assigned an employer signer to every role the template requires',
  },
  noDocuments: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.noDocuments`,
    defaultMessage: 'No documents added yet.',
  },
  noDocumentsError: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.noDocumentsError`,
    defaultMessage:
      'At least one document is required for this stage to work, please add.',
  },
  templateTitleMissing: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.templateTitleMissing`,
    defaultMessage: 'Template title missing',
  },
  uploadDocumentTemplates: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.uploadDocumentTemplates`,
    defaultMessage:
      'Upload document templates in <link>company settings</link> to use in this stage.',
  },
});
